/* eslint react/forbid-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import ReactGA from 'react-ga4';
import config from '../../config';
import { getQuery } from '../utils/url';
import { gaClickEventAction, gaClickEventLabel } from '../utils/gaEvents';
import { flashErrorMessage } from '../actions/flash';
import { checkAuthenticated } from '../actions/auth';
import { startSessionWatch } from '../utils/sessionWatch';
import { mountQHelpWidget, setQHelpWidgetLanguage } from '../utils/qHelpWidget';
import i18n from '../i18n';

export default class Root extends Component {
  componentDidMount() {
    const { store } = this.props;
    const next = getQuery().next || null;

    moment.tz.setDefault(config.get('tzName') || 'Asia/Kuala_Lumpur');

    if (config.get('server') === 'staging' || config.get('server') === 'development') {
      document.title = `${document.title} Demo`;
    }
    store.dispatch(checkAuthenticated(next))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
    document.addEventListener('click', this.handleClick, false);
    // MS-6466: bounds the superseded-session zombie window at one interval (and ~zero on tab
    // refocus). Root lives for the app's lifetime — BookDash unmounts on navigation.
    this.stopSessionWatch = startSessionWatch({
      isAuthenticated: () => store.getState().auth.isAuthenticated,
    });
    // Q Help: Q's in-app chat (the widget's contact card when Q refuses or is out of reach).
    // One tag for the page, added here once and never by render; no URL for this environment,
    // no tag.
    mountQHelpWidget({
      src: config.get('qHelpWidgetURL'),
      language: i18n.language,
      version: config.get('version'),
    });
    i18n.on('languageChanged', this.handleLanguageChanged);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false);
    i18n.off('languageChanged', this.handleLanguageChanged);
    if (this.stopSessionWatch) {
      this.stopSessionWatch();
    }
  }
  // This tab's own language only (CPI-1310: no cross-tab push); the widget watches data-lang.
  handleLanguageChanged = (language) => {
    setQHelpWidgetLanguage(language);
  }
  handleClick = (event) => {
    if (event.target) {
      const action = gaClickEventAction(event);
      if (action) {
        ReactGA.event('BOOK_CLICK', {
          category: 'BOOK_CLICK',
          action: gaClickEventAction(event),
          route: gaClickEventAction(event),
          label: gaClickEventLabel(event),
          name: gaClickEventLabel(event),
        });
      }
    }
  }
  render() {
    const { store, history, routes } = this.props;
    return (
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  routes: PropTypes.element.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/Root.jsx